import '../styles/Footer.css'

export default function Footer() {
  return (
    <footer>
      <p id="developer">By Gilda Charles</p>
      <div id="socialIcons">
      <a href="linkedin.com/in/gilda-char">
        <i className="fab fa-github"></i>
      </a>
      <a href="https://github.com/gchar031">
        <i className="fab fa-linkedin"></i>
        </a>
      </div>
    </footer>
  );
}
